import React from "react";
import { Box } from "@mui/material";
import { EventProps } from "react-big-calendar";
import moment from "moment";
import { EVENT_TYPE_MAP } from "../../../eventTypes";
import { Booking } from "../../types";

// react-big-calendar renders this for each event; the Booking is carried on
// `event.resource`.
const CalendarEvent: React.FC<EventProps> = ({ event }) => {
  const booking = event.resource as Booking | undefined;
  const meta = booking ? EVENT_TYPE_MAP[booking.type] : undefined;
  const Icon = meta?.icon;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
      {Icon && <Icon sx={{ fontSize: 13, flexShrink: 0 }} />}
      <Box
        component="span"
        sx={{
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {event.title as string}
      </Box>
      {booking && !booking.allDay && (
        <Box component="span" sx={{ fontSize: "0.7rem", opacity: 0.8 }}>
          {moment(booking.from, "HH:mm").format("h:mm A")}
        </Box>
      )}
    </Box>
  );
};

export default CalendarEvent;
